import axios from 'axios'


export function request_zrx(config) {
    //创建实例
    const instance1 = axios.create({
        timeout: 10000,
        baseURL: 'https://stock.ziruxing.com'
    })
    // 拦截器，请求拦截
    instance1.interceptors.request.use(
        config => {
            // console.log(config);
            // 拦截后需要返回
            // 发送网络请求，请求图片转圈
            // 需要token的时候
            return config
        },
        err => {
            console.log(err);
        })
    // 拦截器, 响应拦截
    instance1.interceptors.response.use(
        res => {
            // console.log(res);
            return res
        },
        err => {
            console.log(err);
        })

    // 发送请求
    return instance1(config)
}

export function request_zzquant(config) {
    //创建实例
    const instance1 = axios.create({
        timeout: 20000,
        baseURL: 'https://api.zizizaizai.com'
        // baseURL: 'http://localhost:9001/'
    })
    // 拦截器，请求拦截
    instance1.interceptors.request.use(
        config => {
            // 自动附加登录令牌（若存在）
            try {
                const token = localStorage.getItem('token')
                if (token) {
                    if (!config.headers) config.headers = {}
                    // 兼容JWT默认用法
                    config.headers['Authorization'] = `Bearer ${token}`
                }
            } catch (e) {
                // 忽略localStorage异常
            }
            return config
        },
        err => {
            console.log(err);
        })
    // 拦截器, 响应拦截
    instance1.interceptors.response.use(
        res => {
            // 自动更新 Token 逻辑 (针对旧版 Token 补全昵称)
            const updateToken = res.headers && res.headers['x-update-token']
            if (updateToken) {
                try {
                    localStorage.setItem('token', updateToken)
                    console.log('[Auth] Token has been automatically updated with latest user info.')
                } catch (e) {
                    // 静默失败
                }
            }
            // 统一处理后端返回的未授权提示
            try {
                const data = res && res.data ? res.data : {}
                const code = data.code
                const msg = (data.message || '').toString()
                // 后端常用失败码为50000，搭配"无权限"/"验证失败"等提示
                const needLoginHints = ['无权限', '未登录', '验证失败', 'Unauthorized', '需要登录']
                const needLogin = code !== 20000 && needLoginHints.some(h => msg.indexOf(h) !== -1)
                const noRedirect = res && res.config && res.config.noRedirect
                if (needLogin) {
                    // 跳转到登录页，保留当前跳转来源
                    if (!noRedirect) {
                        try {
                            const router = require('../router').default
                            const current = router.currentRoute && router.currentRoute.fullPath ? router.currentRoute.fullPath : '/'
                            if (router.currentRoute && router.currentRoute.path !== '/login') {
                                router.push({ path: '/login', query: { redirect: current } })
                            }
                        } catch (e) {
                            // 路由不可用时静默
                        }
                    }
                    return Promise.reject({ __unauthorized: true, message: msg || '未授权', code })
                }
            } catch (e) {
                // 忽略解析错误，正常返回
            }
            return res
        },
        err => {
            // 处理HTTP层面的未授权
            try {
                const status = err && err.response ? err.response.status : null
                const noRedirect = err && err.config && err.config.noRedirect

                // 检查 422 错误中的 Token 格式问题 (Flask-JWT-Extended 4.x 升级导致)
                const data = err && err.response && err.response.data ? err.response.data : {}
                const msg = (data.msg || data.message || '').toString()
                const isTokenError = status === 422 && msg.indexOf('Subject must be a string') !== -1

                if ((status === 401 || isTokenError) && !noRedirect) {
                    try {
                        // 清除可能导致问题的旧 Token
                        try { localStorage.removeItem('token') } catch (e) { /* ignore */ }

                        const router = require('../router').default
                        const current = router.currentRoute && router.currentRoute.fullPath ? router.currentRoute.fullPath : '/'
                        if (router.currentRoute && router.currentRoute.path !== '/login') {
                            router.push({ path: '/login', query: { redirect: current } })
                        }

                        // 中断 Promise 链，防止组件报错，等待页面跳转
                        return new Promise(() => { })
                    } catch (e) {
                        // 路由不可用时静默
                    }
                }
            } catch (e) {
                // 忽略跳转异常
            }
            console.log(err);
            return Promise.reject({ __unauthorized: (err && err.response && err.response.status === 401) || false, message: (err && err.message) || '请求错误', status: err && err.response ? err.response.status : null })
        })

    // 发送请求
    return instance1(config)
}

export function request_local(config) {
    //创建实例
    const instance1 = axios.create({
        timeout: 30000, // Backtests can be slow
        baseURL: 'http://127.0.0.1:9001'
    })
    // 拦截器，请求拦截
    instance1.interceptors.request.use(
        config => {
            try {
                const token = localStorage.getItem('token')
                if (token) {
                    if (!config.headers) config.headers = {}
                    config.headers['Authorization'] = `Bearer ${token}`
                }
            } catch (e) {
                console.error(e)
            }
            return config
        },
        err => {
            console.log(err);
        })
    // 拦截器, 响应拦截
    instance1.interceptors.response.use(
        res => {
            return res
        },
        err => {
            console.log(err);
        })

    // 发送请求
    return instance1(config)
}
